export default {
  AUDIO: {
    labels: {
      type: 'Type',
      volt: 'Voltage',
      frequency_mhz: 'Frequency',
      sound_level_db: 'Sound Level',
      current_amp: 'Current Amp',
      brand: 'Brand',
      packing: 'Packing',
      feature: 'Feature',
      wattage: 'Wattage',
      size: 'Size',
      impedance: 'Impedance'
    },
    fields: ['category', 'type', 'volt', 'frequency_mhz', 'sound_level_db', 'current_amp', 'brand', 'packing', 'feature', 'wattage', 'size', 'impedance'],
  },
  ANTENNA: {
    labels: {
      type: 'Type',
      dimension: 'Dimension',
      length: 'Length',
      element: 'Element'
    },
    fields: ['type', 'dimension', 'length', 'element'],
  },
  CABLE: {
    labels: {
      wire_type: 'Wire Type',
      gauge_awg: 'Gauge AWG',
    },
    fields: ['category', 'type', 'color', 'wire_type', 'gauge_awg', 'impedance', 'pitch', 'size', 'brand', 'feature', 'packing', 'series'],
  },
  CAPACITOR: {
    labels: {
      package_case: 'Package Case',
    },
    fields: ['category', 'type', 'volt', 'capacitance', 'tolerance', 'temperature', 'series', 'brand', 'pitch', 'package_case', 'packing', 'feature', 'current'],
  },
  CONNECTOR: {
    labels: {
      current_amp: 'Current Amp',
      contact_pin: 'Contact Pin',
      contact_mat: 'Contact Material',
      mount_type: 'Mount Type',
      number_row: 'Number Row',
      pin_type: 'Pin Type',
    },
    fields: [
      'category', 'type', 'volt', 'current_amp', 'series', 'pitch', 'contact_pin', 'number_row', 'pin_type',
      'gender', 'mount_type', 'color', 'contact_mat', 'feature', 'packing', 'current'
    ],
  },
  CRYSTAL: {
    labels: {
      case_outline: 'Case Outline',
      frequency_mhz: 'Frequency',
      capacitance: 'Load Capacitance',
      package_case: 'Package Case',
    },
    fields: ['category', 'type', 'frequency_mhz', 'capacitance', 'tolerance', 'case_outline', 'brand', 'packing', 'package_case'],
  },
  DISCRETES: {
    labels: {
      leakage_current: 'Leakage Current',
      mount_type: 'Mount Type',
      package_case: 'Package Case',
    },
    fields: ['category', 'type', 'volt', 'leakage_current', 'wattage', 'brand', 'package_case', 'mount_type', 'feature', 'packing']
  },
  TOOL: {
    labels: {
      package_case: 'Package Case',
    },
    fields: ['category', 'type', 'wattage', 'color', 'packing', 'package_case'],
  },
  FAN: {
    labels: {
      air_flow: 'Air Flow',
      current_amp: 'Amp',
      baring_type: 'Baring Type',
    },
    fields: ['category', 'type', 'volt', 'current_amp', 'series', 'size', 'air_flow', 'baring_type', 'brand', 'feature', 'material', 'current']
  },
  COILS: {
    labels: {
      current_amp: 'Current Amp',
    },
    fields: ['category', 'type', 'current_amp', 'frequency_mhz', 'inductance', 'volt', 'tolerance', 'brand', 'packing']
  },
  HEATSHRINK: {
    labels: {},
    fields: ['category', 'type', 'dimension', 'color', 'series', 'brand', 'feature', 'packing']
  },
  IC: {
    labels: {
      current_amp: 'Current Amp',
      current_rating: 'Current Rating',
      mount_type: 'Mount Type',
      package_case: 'Package Case',
    },
    fields: ['category', 'type', 'volt', 'current_rating', 'memory', 'mount_type', 'brand', 'feature', 'package_case', 'packing', 'description']
  },
  LED: {
    labels: {
      light_color: 'Light Color',
      luminous_intensity: 'Luminous Intensity',
      lens_color: 'Lens Color',
      wattage: 'Watts',
    },
    fields: ['category', 'type', 'size', 'light_color', 'lens_color', 'wavelength', 'luminous_intensity', 'volt', 'current_amp', 'wattage', 'brand', 'feature', 'packing']
  },
  OTHERACC: {
    labels: {
      package_case: 'Package Case',
    },
    fields: ['category', 'type', 'material', 'color', 'size', 'packing', 'package_case'],
  },
  VR: {
    labels: {
      current_amp: 'Current Amp',
      v_dcorac: 'V_DCorAC',
      shaft_length: 'Shaft Length',
      package_case: 'Package Case',
    },
    fields: ['category', 'type', 'wattage', 'resistance', 'volt', 'v_dcorac', 'current_amp', 'tolerance', 'series', 'brand', 'package_case', 'shaft_length', 'packing']
  },
  RELAY: {
    labels: {
      contact_rating: 'Contact Rating',
      operating_function: 'Operating Function',
      sensing_distance: 'Sensing Distance',
      volt: 'Coil Voltage',
      mount_type: 'Mount Type',
    },
    fields: ['category', 'type', 'volt', 'contact_rating', 'mount_type', 'operating_function', 'sensing_distance', 'series', 'brand', 'feature', 'color', 'packing', 'current']
  },
  RESISTOR: {
    labels: {
      package_case: 'Package Case',
    },
    fields: ['category', 'type', 'wattage', 'resistance', 'tolerance', 'brand', 'feature', 'package_case', 'packing'],
  },
  SAFETY: {
    labels: {
      current_rating: 'Current Rating',
      max_volt_ac: 'Max Volt AC',
      max_volt_dc: 'Max Volt DC',
      package_case: 'Package Case',
    },
    fields: [
      'category', 'type', 'volt', 'current', 'current_rating', 'series', 'size', 'max_volt_ac', 'max_volt_dc',
      'resistance', 'tolerance', 'temperature', 'brand', 'package_case', 'packing'
    ]
  },
  SOCKET: {
    labels: {
      contact_terminal: 'Contact Terminal',
      row_distance: 'Row Distance',
      number_row: 'Number Row',
      pin_length: 'Pin Length',
      contact_type: 'Contact Type'
    },
    fields: ['category', 'type', 'contact_terminal', 'row_distance', 'number_row', 'pin_length', 'pitch', 'contact_type', 'brand', 'packing']
  },
  SWITCH: {
    labels: {
      current_amp: 'Current Amp',
    },
    fields: ['type', 'volt', 'current', 'current_amp', 'wattage', 'contact', 'size', 'packing', 'pitch', 'brand']
  },
  TESTEQUIP: {
    labels: {
      max_volt_ac: 'Max Volt AC',
      max_volt_dc: 'Max Volt DC',
    },
    fields: ['category', 'type', 'series', 'size', 'volt', 'current', 'max_volt_dc', 'max_volt_ac', 'resistance', 'brand', 'packing']
  }
}
